// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__Ru604","info":"PatientInfo_info__2HVD1"};